import moment from 'moment';

export function useDays() {
  return {
    days() {
      var days = 11;

      if (moment().day() === 0) {
        // If it's Sunday we add 3 days
        days += 3;
      } else if (moment().day() === 6) {
        // If it's Saturday we add 4 days
        days += 4;
      } else {
        // If it's any other day we add 2 days
        days += 2;
      }

      return days;
    },
  };
}

export const TODAY = moment().locale('es');
